import React, { useState, useEffect } from "react";
import OTPModal from "../PasswordAlert";
import { SubscriptionPage } from "../Settings/Subscription/index";
import { Separator } from "../PasswordAlert/styles";
import { ButtonContainer, CancelButton } from "./styles";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import { useGetAllSubcriptions } from "../../services/queries";
import { useQueryClient } from "react-query";
import CouponDisplay from "../CouponDisplay";

export const SignupSubscriptionModal = ({
  open,
  handleCloseModal,
  userId,
  onLoadingChange,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [billingCycle, setBillingCycle] = useState("annual");

  const getSubscriptionLimits = (cycle) =>
    cycle === "annual" ? "annually" : "monthly";
  const subscriptionLimit = getSubscriptionLimits(billingCycle);

  const {
    data: subscriptionsData,
    isLoading: subscriptionsLoading,
    refetch,
  } = useGetAllSubcriptions(subscriptionLimit, { enabled: open });

  // Prepopulate react-query cache once data is available
  useEffect(() => {
    if (subscriptionsData) {
      queryClient.setQueryData(
        ["getAllSubcriptions", subscriptionLimit],
        subscriptionsData
      );
    }
  }, [subscriptionsData, subscriptionLimit, queryClient]);

  // Notify parent about loading status
  useEffect(() => {
    if (open && onLoadingChange) {
      onLoadingChange(subscriptionsLoading);
    }
  }, [subscriptionsLoading, onLoadingChange, open]);

  // Refetch when billing cycle changes
  useEffect(() => {
    if (open) refetch();
  }, [billingCycle, open, refetch]);

  // Do not render modal until data is ready
  if (!open) {
    return null;
  }

  // Show nothing while loading, but the parent will show full-page loader
  if (subscriptionsLoading) {
    return null;
  }

  return (
    <OTPModal
      open={open}
      title="Choose your plan"
      handleClose={handleCloseModal}
      fromSignup={true}
    >
      <div style={{marginBottom: "20px"}}>
          <CouponDisplay />
      </div>
      <SubscriptionPage
        fromSignup={true}
        subscriptionsData={subscriptionsData}
        billingCycle={billingCycle}
        setBillingCycle={setBillingCycle}
      />
      <Separator />
      <ButtonContainer>
        <Button
          style={{ width: "60px" }}
          onClick={() => navigate(`/gallery/${userId}`)}
        >
          Next
        </Button>
      </ButtonContainer>
    </OTPModal>
  );
};
